<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title"><i class="fas fa-comment-dots"></i> {{ "TITLE.DESCRIPTION" | translate }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <table class="table table-bordered">
      <thead class="custom-font-size-table-header">
      <tr>
        <th scope="col" class="custom-col-4">{{ "TABLE.HEADER.DESCRIPTION" | translate }}</th>
      </tr>
      </thead>
      <tbody>
      <tr class="custom-font-size-table-body">
        <td class="custom-col-4">{{description}}</td>
      </tr>
      </tbody>
    </table>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-success" (click)="accept()">{{ "BUTTON.ACCEPT" | translate }}</button>
  </div>
</div>
